const PSConfig = require('PSConfig');
cc.Class({
    extends: cc.Component,

    properties: {
        demoControllerPrefab: cc.Prefab,
        isPersistNode: true
    },

    onLoad() {
        if (window.PSGames.launchParams && window.PSGames.launchParams.cheat) {
            this._init();
        } else {
            this.node.destroy();
        }
    },

    _init() {
        const demoNode = cc.instantiate(this.demoControllerPrefab);

        demoNode.name = 'DemoController';
        demoNode.parent = this.node;

        if (this.isPersistNode) {
            cc.game.addPersistRootNode(this.node);
        }
    }
});
